var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagicWand = function SvgMagicWand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    className: "magic-wand_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.976 191.982 127.988 63.994H63.994v63.994l127.988 127.988zM319.97 0h63.994v127.988H319.97zm255.975 319.97h127.988v63.994H575.945zm63.994-191.982V63.994h-63.994L447.957 191.982l63.994 63.994zM0 319.97h127.988v63.994H0zm319.97 255.975h63.994v127.988H319.97zm-255.976 0v63.994h63.994l127.988-127.988-63.994-63.994zM1009.888 881.9 373.852 245.865a48.123 48.123 0 0 0-67.897 0l-60.09 60.09a48.123 48.123 0 0 0 0 67.897L881.9 1009.888a48.123 48.123 0 0 0 67.898 0l60.09-60.09a48.123 48.123 0 0 0 0-67.898M479.954 543.948 287.973 351.967l63.994-63.994 191.981 191.981z"
  })));
};
export default SvgMagicWand;